import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const screenshots = [{
  src: 'https://cdn.magicpatterns.com/uploads/imUXRqUU2wHJvvEX8mcWzy/testimonio_javi_valencia_quimica.webp',
  alt: 'Testimonio por WhatsApp de un docente sobre los proyectos ABP del MegaPack Química Visual'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iG6779ACs1rKeTYacg57P4/testimonio_ximena_cdmx_quimica.webp',
  alt: 'Testimonio por WhatsApp de la profesora Ximena de CDMX sobre las fichas ilustrativas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/swe7TWhkTb2mtEry4kPx66/testimonio_beatriz_medellin_quimica.webp',
  alt: 'Testimonio por WhatsApp de la profesora Beatriz de Medellín sobre el material organizado por niveles'
}];
export function WhatsAppTestimonials() {
  // Duplicate the list so the marquee can loop seamlessly.
  const loop = [...screenshots, ...screenshots];
  return <section className="py-8 md:py-16 px-4 overflow-hidden" data-id="element-289" data-mp="1c4xj3ebm5bjk">
      {/* Header */}
      <div className="max-w-3xl mx-auto text-center mb-6 md:mb-10" data-id="element-290" data-mp="1c2utuwiabmfw">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-slate-900 mb-3" data-id="element-291" data-mp="sjmlc8cz3hp5">
          Lo que dicen quienes ya compraron
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-slate-600 font-bold text-sm md:text-lg leading-snug" data-id="element-292" data-mp="1780rot9lloag">
          Docentes de toda Latinoamérica ya están usando Química Visual para
          ahorrar tiempo, explicar mejor y trabajar con materiales listos para
          imprimir o usar en digital.
        </motion.p>
      </div>

      {/* Auto-scrolling carousel */}
      <div className="relative" data-id="element-293" data-mp="1z0hx5dyex1sy">
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-8 md:w-24 z-10 bg-gradient-to-r from-sky-100 to-transparent" data-id="element-294" data-mp="1yyx2zpg0fkvm" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-8 md:w-24 z-10 bg-gradient-to-l from-sky-100 to-transparent" data-id="element-295" data-mp="3r21f7i875lxj" />

        <div className="group flex overflow-hidden" data-id="element-296" data-mp="8wobjlj4duft">
          <motion.div className="flex gap-4 md:gap-6 shrink-0 group-hover:[animation-play-state:paused]" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 45,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-297" data-mp="8u25xrfshp08">
            {loop.map((shot, i) => <div key={i} className="shrink-0 w-[220px] md:w-[300px] rounded-3xl overflow-hidden bg-white border border-blue-100 shadow-xl shadow-blue-900/10" data-id="element-298" data-mp="38dea4zq0swjy" data-mpi={i}>
                <img src={shot.src} alt={shot.alt} loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-299" data-mp="3hb6rsaj7sgai" />
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}